

























import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  lawyerLists = [
    {
      src: require('./assets/01.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82482',
    },
    {
      src: require('./assets/02.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82483',
    },
    {
      src: require('./assets/03.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82505',
    },
    {
      src: require('./assets/04.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82508',
    },
    {
      src: require('./assets/05.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82502',
    },
    {
      src: require('./assets/06.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82564',
    },
    {
      src: require('./assets/07.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82286',
    },
    {
      src: require('./assets/08.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82274',
    },
    {
      src: require('./assets/09.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82292',
    },
  ];

  created() {
    // 分享
    this.$appShareInfo({
      title: '洪水留下的疑问 这里有解答',
      url: window.location.href,
      subtitle: '有问题，就到上游新闻帮帮频道',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    this.$wxShareInfo({
      title: '洪水留下的疑问 这里有解答',
      subtitle: '有问题，就到上游新闻帮帮频道',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  onNavTo(person: any) {
    window.location.href = person.target;
    // window.open(person.target);
  }
}
